import { apiRoutes } from "../../config"
import { api } from "../../utils/lib/api"

export const accHomeCenter = async (method, ent, data) => {
    console.log('ent', ent)
    try {
        if (method === "POST") {
            const url = `${apiRoutes.homeCenter.acc}/create-account/${ent}`
            return (await api.post(url, data)).data
        }
        if (method === "GET") {
            const url = `${apiRoutes.homeCenter.acc}/get-account/${ent}`
            const response = (await api.get(url)).data

            if (response && response.data) {
                return { data: response.data }
            }
            return { data: [] }
        }
    } catch (error) {
        console.error(error)
        return error
    }
}

export const syncProductsHomeCenter = async (ent, accUser) => {
    try {
        //Obtenemos el id de la cuenta de Home Center
        const url = `${apiRoutes.homeCenter.products}/sync-massive-products-by-barcode/${ent}`
        return (await api.get(url)).data
    } catch (error) {
        console.log(error)
        throw new Error(error)
    }
}

export const updateProductsHomeCenter = async (ent, accUser, skuId) => {
    try {
        //Obtenemos el id de la cuenta de Home Center
        const url = `${apiRoutes.homeCenter.products}/update-stocks-products-eans/${ent}`
        return (await api.post(url)).data
    } catch (error) {
        console.log(error)
        throw new Error(error)
    }
}

export const getMarketPlacesHomeCenter = async (ent, accUser) => {
    try {
        console.log(`accUser: ${accUser}`);
        const accId = await accHomeCenter('GET', ent, accUser).then((res) => Object.values(res.data).map(item => item._id))
        console.log(`accId: ${accId}`);
        const url = `${apiRoutes.homeCenter.campaigns}/${ent}/acc/${accId}/fetchHomeCenterMarketplaces`
        return (await api.get(url))
    } catch (error) {
        console.log(error)
        throw new Error(error)
    }
}

export const sendCampaignHomeCenter = async (ent, accUser, data) => {
    try {
        console.log(`accUser: ${accUser}`);
        const accId = await accHomeCenter('GET', ent, accUser).then((res) => Object.values(res.data).map(item => item._id))
        console.log(`accId: ${accId}`);
        const url = `${apiRoutes.homeCenter.campaigns}/${ent}/acc/${accId}/createCampaign`
        console.log(`URL: ${url}`)
        console.log(`Data: ${JSON.stringify(data)}`)
        return (await api.post(url, data))
    } catch (error) {
        console.log(error)
        throw new Error(error)
    }
}

export const getCampaignHomeCenter = async (ent) => {
    try {
        const url = `${apiRoutes.homeCenter.campaigns}/${ent}/fetchHomeCenterCampaigns`
        console.log(`URL: ${url}`)
        return (await api.get(url))
    } catch (error) {
        console.log(error)
        throw new Error(error)
    }
}

export const deleteCampaignHomeCenter = async (ent, accUser, data) => {
    try {
        console.log(`accUser: ${accUser}`);
        const accId = await accHomeCenter('GET', ent, accUser).then((res) => Object.values(res.data).map(item => item._id))
        console.log(`accId: ${accId}`);
        const url = `${apiRoutes.homeCenter.campaigns}/${ent}/acc/${accId}/deleteCampaign`
        console.log(`URL: ${url}`)
        console.log(`Data: ${JSON.stringify(data)}`)
        return (await api.post(url, data))
    } catch (error) {
        console.log(error)
        throw new Error(error)
    }
}

export const getReportHomeCenter = async (ent, fileType)=>{
    try {
        const url = `${apiRoutes.homeCenter.products}/${ent}/report/${fileType}`
        return (await api.get(url))
    } catch (error) {
        console.log(error)
        throw new Error(error)

    }
}